import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-my-list',
  templateUrl: './my-list.component.html',
  styleUrls: ['./my-list.component.scss']
})
export class MyListComponent {
  constructor() {}
  loaded:boolean = false;

ngOnInit() {


}
refresh(): void {
  window.location.reload();
}
ngAfterViewInit() {
  setTimeout(() => {
    /** spinner ends after 5 seconds */
    this.loaded = true;
  }, 1500);
}
}
